import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { arrayIsDefinedAndContainsKey } from '../shared/array-functions';
import { responseIsSuccess, valueIsNullOrUndefined } from '../shared/helper-functions';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class ChangeCollectionTypeService {
  private apiUrl: string;
  confirmationInfo: any;
  paymentMethod: any;
  billingAddress: any;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api.protocol + environment.api.hostname + environment.api.path;
    this.confirmationInfo = {};
  }

  /*
   * Validate bank account routing number
   * API endpoint: ValidateRoutingNumber?Number=routingNumber
  */
 validateRoutingNumber(routingNumber): Observable<any> {
  const route = 'ValidateRoutingNumber';
  return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.routingNumberQueryParam + '=' + routingNumber)
  .map((res: Response) => {
    return res;
  }).catch((error: any) =>
    Observable.throw(error || 'Server error')
  );
}

  /*
   * Get confirmation data to display to user before executing switch to easy pay
   * API endpoint: ConfirmSwitchToEasyPay?SubID=subscriptionId&CreditPromotionsId=creditPromotionsId
  */
  confirmSwitchToEasyPay(subscriptionId, creditPromotionsId): Observable<any> {
    const route = 'ConfirmSwitchToEasyPay';
    return this.http.get(this.apiUrl + route + '?' + CONSTANTS.api.subscriptionIdQueryParam + '=' + subscriptionId + '&' + CONSTANTS.api.creditPromotionsIdQueryParam + '=' + creditPromotionsId)
    .map((res: Response) => {
      if (responseIsSuccess(res) && arrayIsDefinedAndContainsKey(res, 'CMS_SAM_Get_ConfirmSwitchToEasyPay')) {
        const response = res['CMS_SAM_Get_ConfirmSwitchToEasyPay'][0];
        this.confirmationInfo = {
          creditDescription: response.CreditDescription,
          packageDescription: response.PackageDescSpanish,
          lastCarrierPaymentDate: response.LastCarrierPaymentDate,
          easyPayEffectiveDate: response.EasyPayEffectiveDate,
          nextBillingDate: response.NextBillingDate,
          easyPayBillCycle: response.EasyPayBillCycle,
          monthlyAmount: response.MonthlyAmount,
          stateTax: response.StateTax,
          cityTax: response.CityTax,
          pendingBalance: response.PendingBalance,
          creditBalance: response.CreditBalance,
          paymentTotal: response.PaymentTotal
        }
      }
      return res;
    }).catch((error: any) =>
      Observable.throw(error || 'Server error')
    );
  }

  /*
   * Execute switch to easy pay
   * API endpoint: SwitchToEasyPay
  */
  switchToEasyPay(customerId, subscriptionId, packageId, creditPromotionsId): Observable<any> {
    const route = 'SwitchToEasyPay';
    const payload = {
      BillingAddress: {
        AddressLine1: this.billingAddress['address1'],
        AddressLine2: this.billingAddress['address2'],
        City: this.billingAddress['city'],
        StateID: this.billingAddress['state']['StateID'],
        Country: this.billingAddress['country'],
        ZipCode: this.billingAddress['zipcode'],
        PhoneNumber: this.billingAddress['phoneNumber']
      },
      PaymentMethod: {
        PaymentMethodID: null,
        PaymentTypeID: this.paymentMethod['paymentTypeId'],
        AccountNumber: this.paymentMethod['accountNumber'],
        CreditCardType: this.paymentMethod['creditCardType'],
        CCExpirationMonth: this.paymentMethod['ccExpirationMonth'],
        CCExpirationYear: this.paymentMethod['ccExpirationYear'],
        CreditCardName: this.paymentMethod['creditCardName'],
        CreditCardCVC: this.paymentMethod['creditCardCVC'],
        AbaRouting: this.paymentMethod['abaRouting'],
        Visible: true,
      },
      CustId: customerId,
      SubID: subscriptionId,
      PackageId: packageId,
      CreditPromotionsId: creditPromotionsId
    };
    return this.http.put(this.apiUrl + route, payload)
    .map((res: Response) => {
      return res;
    }).catch((error: any) =>
      Observable.throw(error || 'Server error')
    );
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/change-collection-type.service.ts